import React from "react";
import { Link } from "react-router-dom";
import letterheadHeader from "../core/images/mcconnell-letterhead-header.png";
import letterheadFooter from "../core/images/mcconnell-letterhead-footer.png";

const ImportantChanges = () => (
  <div className="leaflet-page">
    <p className="leaflet-back">
      <Link to="/">Back</Link>
    </p>
    <article className="leaflet">
      <img src={letterheadHeader} alt="McConnell Property" />
      <div className="leaflet__body">
        <h1>Important Changes to Ground Rent Services</h1>
        <p>
          Following a review of our processes for handling sensitive personal
          and payment information, we are introducing changes to improve
          security and efficiency.
        </p>
        <p>
          <strong>From 1 December 2026:</strong>
        </p>
        <ul>
          <li>
            Ground rent payments will{" "}
            <strong>no longer be accepted by telephone</strong>.
          </li>
          <li>
            All payments must be made either securely online at{" "}
            <a className="leaflet__pay" href="https://mcconnells.groundpay.co.uk">
              mcconnells.groundpay.co.uk
            </a>{" "}
            or by cheque.
          </li>
          <li>
            The Ground Rent Department will move to an{" "}
            <strong>email-only service</strong> and the telephone line will be
            withdrawn.
          </li>
        </ul>
        <p>Please direct enquiries to:</p>
        <p>
          <strong>General enquiries</strong>
          <br />
          <a href="mailto:groundrent@mcconnellproperty.com">
            groundrent@mcconnellproperty.com
          </a>
        </p>
        <p>
          <strong>Urgent house sale/completion enquiries</strong>
          <br />
          <a href="mailto:groundrentsale@mcconnellproperty.com">
            groundrentsale@mcconnellproperty.com
          </a>
        </p>
        <p>
          Please note that the{" "}
          <strong>main McConnell Property switchboard</strong> cannot answer
          ground rent enquiries or transfer calls to the Ground Rent
          Department.
        </p>
        <p>
          To help us respond promptly, please include your{" "}
          <strong>property address</strong> and <strong>tenant reference</strong>{" "}
          in all correspondence.
        </p>
        <p>
          We appreciate your cooperation and understanding as these changes are
          implemented.
        </p>
        <p className="leaflet__signoff">
          <strong>Ground Rent Department</strong>
          <br />
          <strong>McConnell Property</strong>
        </p>
      </div>
      <img src={letterheadFooter} alt="McConnell Property contact details" />
    </article>
  </div>
);

export default ImportantChanges;
